import styled from 'styled-components'

export const Page = styled.main`
  width: 100%;
  padding: 42px 20px 70px;
  background: radial-gradient(
      circle at top left,
      rgba(231, 0, 0, 0.05),
      transparent 34%
    ),
    #f8f8f7;
  color: #2d2d2d;

  @media (max-width: 640px) {
    padding: 26px 14px 48px;
  }
`

export const Container = styled.div`
  width: min(980px, 100%);
  margin: 0 auto;
`

export const Hero = styled.header`
  padding: 34px 36px;
  border: 1px solid #ececec;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 14px 38px rgba(28, 28, 28, 0.06);

  @media (max-width: 640px) {
    padding: 26px 22px;
    border-radius: 18px;
  }
`

export const Eyebrow = styled.span`
  display: inline-block;
  margin-bottom: 8px;
  color: #d80000;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

export const Title = styled.h1`
  margin: 0;
  color: #202020;
  font-size: clamp(30px, 5vw, 46px);
  line-height: 1.04;
  font-weight: 800;
`

export const Lead = styled.p`
  max-width: 760px;
  margin: 16px 0 0;
  color: #696969;
  font-size: 16px;
  line-height: 1.7;
`

export const UpdatedAt = styled.div`
  margin-top: 18px;
  color: #999;
  font-size: 12px;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 18px;
`

export const Section = styled.section`
  padding: 26px 30px;
  border: 1px solid #ececec;
  border-radius: 18px;
  background: #fff;

  @media (max-width: 640px) {
    padding: 22px 20px;
    border-radius: 16px;
  }
`

export const SectionTitle = styled.h2`
  margin: 0 0 10px;
  color: #242424;
  font-size: 21px;
  line-height: 1.25;
`

export const Paragraph = styled.p`
  margin: 0;
  color: #626262;
  font-size: 14px;
  line-height: 1.75;

  & + & {
    margin-top: 10px;
  }

  strong {
    color: #333;
  }

  a {
    color: #d80000;
    font-weight: 700;
  }
`

export const List = styled.ul`
  margin: 12px 0 0;
  padding-left: 20px;
  color: #626262;
  font-size: 14px;
  line-height: 1.75;

  li + li {
    margin-top: 6px;
  }

  strong {
    color: #333;
  }
`

export const Highlight = styled.div`
  margin-top: 14px;
  padding: 15px 17px;
  border-left: 4px solid #d80000;
  border-radius: 0 12px 12px 0;
  background: #fff5f5;
  color: #575757;
  font-size: 13px;
  line-height: 1.65;
`

export const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`

export const ValueCard = styled.div`
  padding: 18px;
  border: 1px solid #efefef;
  border-radius: 14px;
  background: #fcfcfc;

  strong {
    display: block;
    margin-bottom: 5px;
    color: #292929;
    font-size: 14px;
  }

  span {
    color: #777;
    font-size: 12px;
    line-height: 1.55;
  }
`
